export const CODE_ID_TOKEN_FAILED = 401;
